<template>
  <div>
    <el-button
      type="text"
      icon="el-icon-circle-plus-outline"
      @click="openModal"
    >
      Create a new music on hold
    </el-button>
    <el-dialog
      class="stacked-modal"
      :visible.sync="modalVisible"
      title="Create a New Musiconhold"
      width="40%"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form>
        <div class="inline-form-group">
          <el-input v-model="createForm.name" placeholder="Enter name">
            <template slot="prefix"><span>Name</span></template>
          </el-input>
        </div>

        <existing-mediafile
          title="Mediafiles"
          :multiple="true"
          :clearState="clearState"
          :newMediafile="newMediafile"
          :tenantId="tenantId"
          @mediafilesSelected="createForm.meIds = $event"
        />
        <div class="inline-form-group">
          <new-mediafile :tenantId="tenantId" @mediafileSaved="newMediafile = $event" />
        </div>

        <div class="inline-form-group">
          <el-button
            class="mt-20"
            :loading="createProcessing"
            type="primary"
            @click="createOperation"
          >
            Create
          </el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import ExistingMediafile from './ExistingMediafile';
import NewMediafile from "./NewMediafile";
import { mapActions } from "vuex";

export default {
  name: "NewMusiconhold",

  props: {
    tenantId: { required: true },
    clearForm: { required: true }
  },

  components: {
    ExistingMediafile,
    NewMediafile
  },

  data() {
    return {
      newMediafile: null,
      clearState: false,
      modalVisible: false,
      createProcessing: false,
      createForm: {
        tenantId: null,
        name: "",
        meIds: [],
        defaultTenant: true
      }
    };
  },

  watch: {
    clearForm(val) {
      if (val) {
        this.clearFields();
      }
    }
  },

  methods: {
    ...mapActions("musiconholds", {
      createMusiconholds: "create"
    }),

    openModal() {
      this.clearState = false;
      this.modalVisible = true;
    },

    createOperation() {
      const createBody = { ...this.createForm };
      createBody.tenantId = this.tenantId;

      this.createProcessing = true;
      this.createMusiconholds(createBody)
        .then(res => {
          this.$notify({
            title: "Success",
            message: "Created successfully!",
            type: "success"
          });
          this.createProcessing = false;
          this.handleClose();
          this.$emit("musiconholdCreated", res);
        })
        .catch(error => {
          if (error.hasOwnProperty("errors")) {
            this.$notify({
              title: error.message,
              message: error.errors[Object.keys(error.errors)[0]],
              type: "error"
            });
          } else {
            this.$notify({
              title: error.name,
              message: error.message,
              type: "error"
            });
          }
          this.createProcessing = false;
          this.clearFormFields = false;
        });
    },

    handleClose() {
      this.clearFields();
      this.modalVisible = false;
    },

    clearFields() {
      this.clearState = true;
      this.newMediafile = null;
      this.modalVisible = false;
      this.createProcessing = false;
      this.createForm = {
        tenantId: null,
        name: "",
        meIds: [],
        defaultTenant: true
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.el-form {
  margin-top: 0 !important;
  padding-top: 0 !important;
}
</style>
